<template>
  <div>
    <div class="my-2">
      <b-collapse id="collapse-1" class="mt-2" v-model="visibleCollapse">
        <b-card>
          <b-form v-on:submit.prevent>
            <b-form-group id="input-group-2" :label="`Código de la ${indicatorName}`" label-for="input-2">
              <b-form-input
                id="input-2"
                v-model="newPerformance.id"
                placeholder="Código"
                disabled
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-1"
              :label="`${indicatorName[0].toUpperCase() + indicatorName.slice(1)}`"
              label-for="textarea"
            >
              <b-form-textarea
                id="textarea"
                v-model="newPerformance.description"
                :placeholder="`Ingrese la ${indicatorName}`"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <b-button variant="primary" @click="savePerformance()">{{ newPerformance.id ? 'Guardar edición' : 'Guardar'}}</b-button>
            <b-button variant="light" class="btn-sm" @click="cancel()">Cancelar</b-button>
          </b-form>
        </b-card>
      </b-collapse>
    </div>
    <a-divider v-if="doesEdit" orientation="left">{{ nameList }}
      <b-button variant="primary" @click="create()" style="position: absolute; right: 2rem; top: -0.5em; z-index: 1;">Crear</b-button>
    </a-divider>
    <div class="my-2">
      <b-container>
        <h5 v-if="!doesEdit" class="mb-4">
          <strong>{{ nameList }}</strong>
        </h5>
        <div class="mb-2">
          <b-form inline v-on:submit.prevent>
            <b-form-input
              id="inline-form-input-ican"
              class="mb-2 mr-sm-2 mb-sm-0"
              :placeholder="`Código/${indicatorName[0].toUpperCase() + indicatorName.slice(1)}`"
              v-model="search"
            ></b-form-input>
            <b-button variant="primary" @click="getIndicatorsList()">Buscar</b-button>
            <b-button variant="light" class="btn-sm" @click="clean()">Cancelar</b-button>
          </b-form>
        </div>
        <b-table v-show="indicator.length > 0" striped hover :fields="columns" :items="indicator" head-variant="light" responsive>
          <template #cell(actions)="indicator">
            <b-link v-if="doesEdit" @click="editIndicator(indicator.item)">Editar</b-link><br v-if="doesEdit">
            <b-link v-if="doesSelect" @click="selectIndicator(indicator.item, 0)">Seleccionar |</b-link><br v-if="doesEdit">
            <b-link v-if="doesSelect" @click="selectIndicator(indicator.item, 1)">Seleccionar para todos</b-link><br v-if="doesEdit">
          </template>
        </b-table>
        <empty-table v-show="indicator.length === 0"/>
        <b-row>
          <b-col>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              @input="getIndicatorsList()"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ pagination.rows }} resultados
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/axios'
import Swal from 'sweetalert2'
import emptyTable from '@/components/custom/cardEmptyList'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'performance',
  components: {
    emptyTable,
  },
  props: {
    idDescriptorSelectedToEdit: {
      type: Number,
      default: 1,
    },
    doesEdit: {
      type: Boolean,
      default: false,
    },
    indicatorType: {
      type: Number,
      default: 1,
    },
    indicatorName: {
      type: String,
      default: '',
    },
    doesSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visibleCollapse: false,
      columns: [
        { key: 'id', label: 'Código', thStyle: { width: '10%' } },
        { key: 'description', label: '' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: '30%' } },
      ],
      indicator: [],
      newPerformance: {
        id: '',
        description: '',
      },
      pagination: {
        rows: 0,
        perPage: 5,
        currentPage: 1,
      },
      search: '',
      nameList: '',
    }
  },
  created: function () {
    this.getIndicatorsList()
  },
  mounted: function () {
    this.columns[1].label = this.indicatorName[0].toUpperCase() + this.indicatorName.slice(1)
    switch (this.indicatorType) {
      case 1:
        this.nameList = 'Lista de fortalezas creadas'
        break
      case 2:
        this.nameList = 'Lista de debilidades creadas'
        break
      case 3:
        this.nameList = 'Lista de recomendaciones creadas'
        break
      default:
        console.log('error')
        break
    }
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  methods: {
    getIndicatorsList() {
      let q = ''
      if (this.search) {
        q += '&search=' + this.search
      }
      apiClient.get(`/performance-indicators?type=${this.indicatorType}&page=${this.pagination.currentPage - 1}&perpage=${this.pagination.perPage + q}`, this.form).then(response => {
        this.indicator = response.data.results.rows
        this.pagination.rows = response.data.results.count
      }).catch(err => {
        Toast.fire({
          icon: 'warning',
          title: 'Ooops ocurrio un error ' + showErrorMessage(err),
        })
      })
    },
    clean() {
      this.search = ''
      this.getIndicatorsList()
    },
    savePerformance() {
      this.newPerformance.description = this.newPerformance.description.trim()
      if (this.newPerformance.description.length === 0) {
        Toast.fire({
          icon: 'warning',
          title: 'La descripción de la ' + this.indicatorName + ' no debe estar vacía.',
        })
        return
      }
      const sentPerformance = this.newPerformance
      sentPerformance.indicatorName = this.indicatorName
      sentPerformance.type = this.indicatorType
      if (this.newPerformance.id) { // Ya existe el id entonces se edita
        this.saveEditPerformance()
      } else { // Se crea por primera vez
        apiClient.post('/performance-indicators', sentPerformance).then(response => {
          this.newPerformance.id = response.data.id
          Toast.fire({
            icon: 'success',
            title: `${this.indicatorName[0].toUpperCase() + this.indicatorName.slice(1)} creada correctamente con el código ${response.data.id}.`,
          })
          this.getIndicatorsList()
          this.visibleCollapse = false
        }).catch(err => {
          Toast.fire({
            icon: 'warning',
            title: 'Ooops ocurrio un error ' + showErrorMessage(err),
          })
        })
      }
    },
    saveEditPerformance() {
      apiClient.patch('/performance-indicators/' + this.newPerformance.id, this.newPerformance).then(response => {
        Toast.fire({
          icon: 'success',
          title: `Se modificó la ${this.indicatorName} con el código ${response.data.id} correctamente.`,
        })
        this.getIndicatorsList()
        this.visibleCollapse = false
      }).catch(err => {
        Toast.fire({
          icon: 'warning',
          title: 'Ooops ocurrio un error ' + showErrorMessage(err),
        })
      })
    },
    cancel() { // Boton cancelar
      this.newPerformance = {
        id: '',
        description: '',
        dimension: 'SER',
      }
      this.visibleCollapse = false
    },
    create() { // Boton crear
      this.newPerformance = {
        id: '',
        description: '',
        dimension: 'SER',
      }
      this.visibleCollapse = !this.visibleCollapse
    },
    editIndicator(indicator) {
      this.newPerformance = indicator
      this.visibleCollapse = true
    },
    selectIndicator(indicator, type) {
      this.$emit('indicator', indicator, type)
    },
  },
}
</script>
